/** Sales order list → Fulfilment eligibility. */

const statusId = order => order?.status?.id ?? order?.status;

/**
 * @param {Array<object>} orders
 * @returns {{ ok: boolean, reason: string }}
 */
export const fulfilmentSelectionState = orders => {
  if (!orders?.length) {
    return { ok: false, reason: "Select at least one sales order." };
  }

  const draftOrCancelled = orders.filter(order => {
    const id = statusId(order);
    return id === "draft" || id === "cancelled";
  });
  if (draftOrCancelled.length) {
    const label = draftOrCancelled[0].name || `SO ${draftOrCancelled[0].id}`;
    const id = statusId(draftOrCancelled[0]);
    return {
      ok: false,
      reason: `Fulfilment is not available for draft or cancelled orders (${label} is ${id}).`,
    };
  }

  return { ok: true, reason: "" };
};

/**
 * @param {Array<number|string>} orderIds
 * @returns {{ sale_order_ids: number[] }}
 */
export const fulfilmentBatchBody = orderIds => ({
  sale_order_ids: orderIds.map(id => Number(id)),
});
